import { render, staticRenderFns } from "./ListBillingChangeRequests.vue?vue&type=template&id=0fca212d"
import script from "./ListBillingChangeRequests.vue?vue&type=script&lang=ts"
export * from "./ListBillingChangeRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports